import React from 'react';
export default {
  'cart': {
    'change-currency': 'Skift valuta',
    'and-then': 'Og så',
    'plus-tax': ' + skat',
    'for': 'For',
    'edit': {
      'label': 'Rediger',
      'submit': 'Anvend'
    },
    'empty': 'Du har ikke tilføjet noget til din bestilling endnu.',
    'free': 'gratis',
    'promo-code': {
      'add': 'Tilføj gavekort eller rabatkode',
      'error': {
        'invalid-for-subscription': 'Kuponkoden er ikke gyldig for denne ordre.'
      },
      'label': 'Gavekort eller rabatkode',
      'submit': 'Anvend'
    },
    'subtotal-line': {
      'tax-label': 'Estimeret skat',
      'subtotal': 'Subtotal',
      'tax': 'Moms',
      'gift-card': 'gavekort'
    },
    'starting-price': 'Startpris',
    'title': 'Ordre Resumé',
    'setup-fee': 'opsætning gebyr',
    'free-trial': 'gratis prøveversion',
    'total-line': {
      'label': 'I alt'
    },
    'order-total-line': {
      'label': 'Ordre total'
    }
  },
  'address': {
    'country': 'Land',
    'address2': 'Lejlighed, suite, etc.',
    'tax-identifier': 'Skatteidentifikator',
    'tax-identifier-type': 'Skatteidentifikatortype',
    'first-name': 'Fornavn',
    'last-name': 'Efternavn',
    'company-name': 'Virksomhedsnavn',
    'address1': 'Vej',
    'city': 'By',
    'state': 'Provins',
    'postal-code': 'Postnummer',
    'phone-number': 'Telefonnummer',
    'vat-number': 'Moms-nr./Skatte-ID'
  },
  'payment-method': {
    'credit-card': {
      'label': 'Kortdetaljer',
      'expiry': 'MM/ÅÅ',
      'name': 'Kreditkort',
      'number': 'Kortnummer',
      'cvv': 'CVV',
      'brand': {
        'visa': 'Visa',
        'master': 'MasterCard',
        'cartes_bancaires': 'Cartes Bancaires'
      }
    },
    'ach': {
      'name': 'Bankkonto',
      'routing-number': 'Routing Number',
      'account-number': 'Kontonummer',
      'account-number-confirmation': 'Bekræft kontonummer',
      'account-type': {
        'label': 'Kontotype',
        'checking': 'Checkkonto',
        'savings': 'Opsparingskonto'
      },
      'name-on-account': 'Navn på konto'
    },
    'amazon': {
      'name': 'Amazon'
    },
    'apple-pay': {
      'name': 'Apple Pay'
    },
    'boleto': {
      'name': 'Boleto'
    },
    'bacs': {
      'name': 'Bacs',
      'sort-code': 'Sort Kode'
    },
    'becs': {
      'name': 'BECS',
      'bsb-code': 'BSB Kode'
    },
    'google-pay': {
      'name': 'Google Pay'
    },
    'ideal': {
      'name': 'Ideal'
    },
    'paypal': {
      'name': 'PayPal'
    },
    'qiwi_wallet': {
      'name': 'Qiwi Wallet'
    },
    'sepa': {
      'name': 'SEPA',
      'iban': 'IBAN'
    },
    'sofort': {
      'name': 'Sofort'
    },
    'venmo': {
      'name': 'Venmo'
    }
  },
  'billing-address': 'Faktureringsadresse',
  'billing-address-same-as-shipping': 'Samme som leveringsadresse',
  'submit': 'Betal nu',
  'payment-method-selected': ({ paymentMethod }: { paymentMethod: string }) => <>{paymentMethod} valgt</>,
  'express-checkout': 'Ekspresbetaling',
  'change-payment-method': 'Skift betalingsmetode',
  'day': 'dag',
  'days': 'dage',
  'week': 'uge',
  'weeks': 'uger',
  'month': 'måned',
  'months': 'måneder',
  'year': 'år',
  'years': 'år',
  'confirmation': {
    'title': 'Mange tak for din ordre',
    'order-num': ({ number }: { number: number }) => <>Ordre #{number}</>,
    'fulfilled-on': ({ date }: { date: string }) => <>Udført den {date}</>,
    'email-notice': 'Du vil modtage en bekræftelse til din e-mail på din ordre.',
    'payment': 'Betaling',
    'return-to': ({ name }: { name: string }) => <>Retur til {name}</>,
    'credit-applied': 'Kredit tilladt'
  },
  'back': 'Tilbage',
  'contact-info': 'Kontaktinformation',
  'email-address': 'email',
  'payment-info': 'Faktureringsoplysninger',
  'shipping-address': 'Leveringsadresse',
  'legal': {
    'accept': 'Jeg accepterer',
    'privacy-policy': 'Privatlivspolitik',
    'terms-of-service': 'Servicevilkår'
  },
  'recurring': {
    'consent': `Jeg accepterer at betale ovenstående gebyrer, der vises med en betalingsfrekvens,
                på tilbagevendende basis, medmindre abonnementet opsiges før den aktuelle betalingsperiode udløber.`,
    'cancel': 'For at opsige dit abonnement skal du gå til din Kontoadministreringsside.'
  },
  'pluralize': {
    'days': ({ count }: { count: number }) => count === 1 ? 'dag' : 'dage',
    'weeks': ({ count }: { count: number }) => count === 1 ? 'uge' : 'uger',
    'months': ({ count }: { count: number }) => count === 1 ? 'måned' : 'måneder',
    'years': ({ count }: { count: number }) => count === 1 ? 'år' : 'år'
  },
  'subscription': {
    'details': {
      'addons': {
        'flat.charge': ({ amount, addOnName }: { amount: string, addOnName: string }) => <>Du bliver opkrævet {amount}/enhed for {addOnName}</>,
        'no-flat.charge': ({ amount, units, unitsLabel, addOnName }: { amount: string, units: number, unitsLabel: string, addOnName: string }) => <>Du bliver opkrævet {amount} for {units} {unitsLabel} af {addOnName}</>
      },
      'billing.starting': ({ startDate, amount, intervalLengthLabel, taxable = true }: { startDate: string, amount: string, intervalLengthLabel: string, taxable?: boolean }) => <>Fra {startDate} vil du blive opkrævet {amount}/{intervalLengthLabel}{taxable ? ' + moms' : ''}</>,
      'billing.starting.setupfee': ({ startDate, amount, intervalLengthLabel, setupFee, taxable = true }: { startDate: string, amount: string, intervalLengthLabel: string, setupFee: string, taxable?: boolean }) => <>Fra {startDate} vil du blive opkrævet {amount}/{intervalLengthLabel}{taxable ? ' + moms' : ''}, sammen med et engangsgebyr på {setupFee}</>,
      'cancellation.reminder': 'Du vil modtage en e-mail påmindelse {days} dage før faktureringen begynder.',
      'trial.start': ({ trialLength, trialInterval }: { trialLength: number, trialInterval: string }) => <>Din gratis {trialLength} {trialInterval} dages prøve begynder i dag.</>,
      'trial.ends': ({ trialEndsAt }: { trialEndsAt: string }) => <>For at undgå at blive opkrævet skal du opsige din prøve før . {trialEndsAt}.</>,
      'email.reminder': ({ days }: { days: number }) => <>Du modtager en e-mailpåmindelse {days} dage før betalingen starter.</>,
      'no-renewal': ({ billingEndsAt }: { billingEndsAt: string }) => <>Dit abonnement slutter den {billingEndsAt} og bliver ikke automatisk fornyet.</>,
      'ramp.after': ({ afterChargeTime, newChargeAmount }: { afterChargeTime: string, newChargeAmount: string }) => <>Efter {afterChargeTime} vil du blive opkrævet {newChargeAmount} + skat.</>,
      'renewal': ({ totalCyclesLengthLabel }: { totalCyclesLengthLabel: string }) => <>Dit abonnement bliver automatisk fornyet hver {totalCyclesLengthLabel} måned, indtil du opsiger det.</>,
      'title': 'Abonnementsoplysninger',
    },
    'agreement.button': 'Accepter & Fortsæt',
    'agreement.text': 'Ved at klikke på "Accepter & Fortsæt" bekræfter du, at du forstår og accepterer disse abonnementsvilkår. Der bliver ikke opkrævet gebyrer, før du fuldfører købet.',
    'changeOrCancel': 'For at ændre eller opsige dit abonnement ',
    'access-account': 'få adgang til din konto',
    'contact-support': 'kontakt support',
  },
  'currency-display': ({ currency }: { currency: string }) => <>{(currency || '').toUpperCase()}</>,
  'support': {
    'array': {
      'wordsConnector': ', ',
      'twoWordsConnector': ' og ',
      'lastWordConnector': ' og '
    }
  },
  'powered-by': ({ recurly }: { recurly: string }) => <>Abonnement fakturering drevet af {recurly}</>,
  'errors': {},
  'subscribe': 'Abonner'
};
